<template>
  <div
    class="bg-overlay-low rounded-lg absolute inset-0 z-20 overflow-hidden"
    :class="{
      'opacity-100': isOpaque,
      'opacity-90': !isOpaque,
    }"
  >
    <div
      class="inset-0 flex h-full w-full flex-col items-center justify-center"
      :class="{
        'bg-overlay-hi': isOpaque,
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ isOpaque: boolean }>()
</script>
